import { useMemo } from 'react';

import { useAppSelector } from '@hooks/redux';

import { canListCustomUserProperties } from '../utils/can-list-custom-user-properties';

export function useCanListCustomUserProperties() {
  const organisationPermissions = useAppSelector(
    (state) => state.permissions?.organisation || []
  );
  const networkPermissionsById = useAppSelector(
    (state) => state.permissions?.networks || {}
  );

  return useMemo(
    () => canListCustomUserProperties({
      organisationPermissions,
      networkPermissionsById,
    }),
    [organisationPermissions, networkPermissionsById]
  );
}
